<div class="sections">
  <section>
    <div class="container">
      <div class="form-wrap" *ngIf="!submitted">
        <h2 class="title">{{"feedback.title" | translate}}</h2>
        <p class="note">{{"feedback.note" | translate}}</p>
        <form [formGroup]="formGroup">
          <div class="form-fields">
            <div class="field text">
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>{{"contactUs.name" | translate}}</mat-label>
                <input matInput formControlName="name"/>
                <mat-error
                  *ngIf="formGroup.get('name').touched && formGroup.get('name').hasError('required')">{{ "global.required" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="field text">
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>{{"contactUs.companyName" | translate}}</mat-label>
                <input matInput formControlName="companyName"/>
              </mat-form-field>
            </div>

            <div class="field">
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>{{"feedback.feedback" | translate}}</mat-label>
                <textarea matInput rows="4" formControlName="message"></textarea>
                <mat-error
                  *ngIf="formGroup.get('message').touched && formGroup.get('message').hasError('required')">{{ "global.required" | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="field message">
              <mat-checkbox formControlName="publish">{{"feedback.publish" | translate}}</mat-checkbox>
            </div>

            <div class="actions">
              <button mat-button="filled" class="main"
                      (click)="onSubmit()" [disabled]="loading">
                <mat-spinner *ngIf="loading" active-indicator-width="25" class="animated-loading"></mat-spinner>
                {{"feedback.send" | translate}}
              </button>
            </div>
          </div>
        </form>
      </div>
      <div class="form-wrap success" *ngIf="submitted">
        <div class="image-wrap">
          <img src="assets/svgs/feedback.svg" alt="Contact us"/>
        </div>
        <h2 class="title">{{"feedback.success" | translate}}</h2>
      </div>
    </div>
  </section>
</div>
